import { useRef, useState } from 'react'

import { CHARACTER_WHITESPACE } from '../../../../constants/common'
import {
  EVENT_NAME_BLUR,
  EVENT_NAME_FOCUS,
  EVENT_NAME_SCROLL,
} from '../../../../constants/event'
import {
  WYSIWYG_EDITOR_EVENT_NODE_CHANGE,
  WYSIWYG_EDITOR_EVENT_REMOVE,
  WYSIWYG_EDITOR_EVENT_RESIZE_EDITOR,
  WYSIWYG_EDITOR_EVENT_SELECTION_CHANGE,
} from '../../../WysiwygEditor'

import { isEmailReplyFormCaretUnderButton } from './useEmailReplyFormConversationButtonOverlap.utils'

// the `…` button floats over the editor content, so it steps aside while the
// caret is right under it
export function useEmailReplyFormConversationButtonOverlap() {
  const buttonRef = useRef(null)

  const [isCaretUnderButton, setCaretUnderButton] = useState(false)

  function handleInitEditor(editor) {
    function handleCheckOverlap() {
      setCaretUnderButton(
        isEmailReplyFormCaretUnderButton({ button: buttonRef.current, editor })
      )
    }

    const editorWindow = editor.getWin()

    function handleRemove() {
      document.removeEventListener(EVENT_NAME_SCROLL, handleCheckOverlap, true)
      editorWindow.removeEventListener(EVENT_NAME_SCROLL, handleCheckOverlap)
    }

    editor.on(
      [
        EVENT_NAME_BLUR,
        EVENT_NAME_FOCUS,
        WYSIWYG_EDITOR_EVENT_NODE_CHANGE,
        WYSIWYG_EDITOR_EVENT_RESIZE_EDITOR,
        WYSIWYG_EDITOR_EVENT_SELECTION_CHANGE,
      ].join(CHARACTER_WHITESPACE),
      handleCheckOverlap
    )
    editor.on(WYSIWYG_EDITOR_EVENT_REMOVE, handleRemove)

    document.addEventListener(EVENT_NAME_SCROLL, handleCheckOverlap, {
      capture: true,
      passive: true,
    })
    editorWindow.addEventListener(EVENT_NAME_SCROLL, handleCheckOverlap, {
      passive: true,
    })
  }

  return {
    buttonRef,
    handleInitEditor,
    isCaretUnderButton,
  }
}
